import React from 'react'
import { UploadHeader } from "../components/uploadHeader";
import './myProfileUploadDocumentationStatus.scss'
import PropTypes from "prop-types";
import { recordLinkV2 } from "utilities/tagging";
import { UPLOAD_DOCUMENTATION } from "constants/tagging";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { DOCUMENTATION_UPLOAD_PROCESS_URL, DOCUMENTATION_URL, MYPROFILE_GLOBAL_URL } from "constants/index";
import { recordPage } from "utilities/tagging";
import { translateText } from "../getTranslationsMyProfileUploadDocumentation";
import ArrowNextIcon from 'assets/icons/action-arrow-next.svg'

const { OKButton } = require('commonsComponents/OKButton')

export class MyProfileUploadDocumentationStatus extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { history, myProfileUploadDocumentation } = this.props
        const processSelected = myProfileUploadDocumentation.get('processSelected').get('label')

        if (!processSelected) {
            history.push(MYPROFILE_GLOBAL_URL);
        }

        recordPage({
            nombrePagina: `${UPLOAD_DOCUMENTATION}/${processSelected}/${this.getLabelByStatus()}`,
            tipoProceso: `${UPLOAD_DOCUMENTATION}/${processSelected}`,
            pasoProceso: this.getLabelByStatus(),
        })
    }

    getLabelByStatus = () => {
        const { status } = this.props
        const labelByStatus = {
            "success": "exito",
            "error": "error"
        }

        return labelByStatus[status]
    }

    recordEvent = (extraData) => {
        const dataToRecord = {
            categoriaEvento: `${UPLOAD_DOCUMENTATION}/<selected option>/${this.getLabelByStatus()}`,
            ...extraData
        }

        recordLinkV2(dataToRecord)
    }

    handleOnClickGoBack = (e) => {
        e.preventDefault()
        this.recordEvent({
            accionEvento: "volver a documentacion"
        })

        this.props.history.push(DOCUMENTATION_URL);
    }

    handleOnClickUploadMore = (e) => {
        e.preventDefault()
        this.recordEvent({
            accionEvento: "subir mas documentos"
        })

        this.props.history.push(DOCUMENTATION_UPLOAD_PROCESS_URL);
    }

    render() {
        const { icon, showButton, title, text } = this.props

        return (
            <React.Fragment>
                <UploadHeader />
                <div className="upload-status-container grid-view__body">
                    <div className="col-xs-12 col-md-12">
                        <div className="status-container">
                            <div className="status-image-container">
                                <img alt="status-icon" src={icon} />
                            </div>

                            <div className={"data-container"}>
                                <div className={"text-container"}>
                                    <div className={"title-container"}>
                                        <h3>{title}</h3>
                                    </div>
                                    <div className={"information-text"}>
                                        {text}
                                    </div>
                                    {showButton && (
                                        <div>
                                            <OKButton modifier="primary" onClick={this.handleOnClickUploadMore}>
                                                {translateText('buttonUploadMoreDocuments')}
                                            </OKButton>
                                        </div>)
                                    }
                                </div>

                                <div className={"footer-container"}>
                                    <a href={"#"} onClick={this.handleOnClickGoBack}>
                                        {translateText('buttonDocumentArea')}
                                        <img src={ArrowNextIcon} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

module.exports.constructor = MyProfileUploadDocumentationStatus
export default connect(state => ({
    myProfileUploadDocumentation: state.myProfileUploadDocumentation,
}))(withRouter(MyProfileUploadDocumentationStatus));

MyProfileUploadDocumentationStatus.propTypes = {
    showButton: PropTypes.bool,
    icon: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    status: PropTypes.string,
    myProfileUploadDocumentation: PropTypes.object,
    history: PropTypes.object.isRequired,
};
